/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 端口IP模式
 */
export enum PortIPModeE {
    //静态模式
    STATIC = 0,
    //动态模式
    DYNAMIC = 1,
}
